"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Overlay.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
Component to display a Overlay
*/
function Overlay(_ref) {
  var className = _ref.className,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      status = _ref.status,
      componentRef = _ref.componentRef,
      renderNode = _ref.renderNode,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "onDismiss", "children", "status", "componentRef", "renderNode"]);

  var cssClasses = ['st_overlay', "st_overlay--" + status];
  var OverlayClasses = ['st_overlay__content'];
  OverlayClasses = utils.classNames.addClassNames(className, OverlayClasses);
  var contentRef = (0, _react.useRef)(null); // handle when X is clicked to manually close Overlay

  var handleDismiss = (0, _react.useCallback)(function () {
    if (onDismiss) onDismiss();
  }, [onDismiss]); // close when user clicks on scrim

  var listenClick = (0, _react.useCallback)(function (e) {
    if (contentRef.current && !contentRef.current.contains(e.target)) {
      handleDismiss();
    }
  }, [handleDismiss, contentRef]);
  var listenKeyboard = (0, _react.useCallback)(function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      handleDismiss();
    }
  }, [handleDismiss]); // listen for Esc key

  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', listenKeyboard);
    return function () {
      return window.removeEventListener('keydown', listenKeyboard);
    };
  }, [listenKeyboard]);
  /* eslint-disable */
  // need to disable some a11y rules around clicking the scrim to close modal
  // the key event is attached to window already
  // eslint-disable jsx-a11y/click-events-have-key-events jsx-a11y/no-static-element-interactions

  var content = /*#__PURE__*/_react["default"].createElement("div", {
    className: cssClasses.join(' '),
    ref: componentRef,
    onClick: listenClick,
    "aria-label": "press Esc to close"
  }, /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: OverlayClasses.join(' ')
  }, otherProps, {
    role: "dialog",
    ref: contentRef
  }), children));
  /* eslint-enable */


  if (status === 'initial' || status === 'closed') return null;
  if (!renderNode) return content;
  return _reactDom["default"].createPortal(content, renderNode);
}

Overlay.propTypes = {
  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** callback when Overlay is dismissed, either via the X icon, or by pressing Esc */
  onDismiss: _propTypes["default"].func,

  /** node where Overlay should be rendered */
  renderNode: _propTypes["default"].any,

  /** status of Overlay, generally should be open or closed */
  status: _propTypes["default"].oneOf(['initial', 'beforeopen', 'opening', 'closing', 'closed', 'open']),

  /** ref for element */
  componentRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })])
};
Overlay.defaultProps = {
  className: null,
  onDismiss: function onDismiss() {
    return null;
  },
  renderNode: null,
  status: 'initial',
  componentRef: null
};
Overlay.displayName = 'Overlay';
var _default = Overlay;
exports["default"] = _default;